/* eslint-disable no-console */

let updateAvailable = false;
let waitingWorker = null;
let updatePromptVisible = false;
let reloadWhenUpdated = false;
let serviceWorkerRegistration = null;
let lastUpdateCheckAt = 0;

const UPDATE_CHECK_INTERVAL_MS = 60000;

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      // Service worker is at the root, not under /d/
      const swUrl = '/service-worker.js';

      navigator.serviceWorker
        .register(swUrl, { scope: '/', updateViaCache: 'none' })
        .then((registration) => {
          console.log('Service Worker registered:', registration);
          serviceWorkerRegistration = registration;

          detectWaitingUpdate(registration);

          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker == null) {
              return;
            }
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // New update available
                  console.log('New content is available and will be loaded on next visit.');
                  waitingWorker = registration.waiting || installingWorker;
                  updateAvailable = true;
                  
                  // Don't prompt immediately - wait for safe moment
                  // The update will activate on next page load
                  showUpdateNotification();
                } else {
                  // Content is cached for offline use
                  console.log('Content is cached for offline use.');
                }
              }
            };
          };

          // Check immediately, then periodically while the app remains open.
          checkForUpdate(true);
          setInterval(checkForUpdate, UPDATE_CHECK_INTERVAL_MS);
        })
        .catch((error) => {
          console.error('Error during service worker registration:', error);
        });
    });

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!reloadWhenUpdated) {
        return;
      }

      reloadWhenUpdated = false;
      window.location.reload();
    });

    // Handle page visibility - check for updates when user returns
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        if (updateAvailable) {
          showUpdateNotification();
        } else {
          checkForUpdate();
        }
      }
    });

    window.addEventListener('focus', () => {
      if (updateAvailable) {
        showUpdateNotification();
      } else {
        checkForUpdate();
      }
    });

    window.addEventListener('online', () => checkForUpdate(true));
  }
}

async function checkForUpdate(force = false) {
  if (!serviceWorkerRegistration || !navigator.onLine) {
    return;
  }

  const now = Date.now();
  if (!force && now - lastUpdateCheckAt < UPDATE_CHECK_INTERVAL_MS) {
    return;
  }

  lastUpdateCheckAt = now;
  try {
    await serviceWorkerRegistration.update();
    detectWaitingUpdate(serviceWorkerRegistration);
  } catch (error) {
    console.error('Service Worker update check failed:', error);
  }
}

function detectWaitingUpdate(registration) {
  if (
    !registration
    || !registration.waiting
    || !navigator.serviceWorker.controller
    || reloadWhenUpdated
  ) {
    return;
  }

  if (!updateAvailable || waitingWorker !== registration.waiting) {
    waitingWorker = registration.waiting;
    updateAvailable = true;
    showUpdateNotification();
  }
}

function showUpdateNotification() {
  if (updatePromptVisible || !waitingWorker) {
    return;
  }

  // Check if user is offline - never prompt if offline
  if (!navigator.onLine) {
    console.log('Update available but user is offline - will apply on next online visit.');
    return;
  }

  // Safe to prompt for update
  updatePromptVisible = true;
  const userWantsUpdate = window.confirm(
    'New version available! Reload to update?\n\n(Your data is saved and will not be lost)'
  );
  updatePromptVisible = false;
  
  if (userWantsUpdate) {
    updateAvailable = false;
    reloadWhenUpdated = true;
    waitingWorker.postMessage({ type: 'SKIP_WAITING' });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
